/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IEnderecoRepository } from "@/interface/enderecos";

const enderecosRepository: IEnderecoRepository = {
  async atualizarEndereco(accessToken, endereco_id, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.put(`enderecos/${endereco_id}`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },

  async buscarPorUmEndereco(accessToken, endereco_id) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.get(`enderecos/${endereco_id}`, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },

  async buscarEnderecosSeparadosPorTipo(accessToken, user_id) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.get(`enderecos/usuarios/${user_id}/enderecos-por-tipo`, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },
};

/**
 * EXPORTS
 */
export { enderecosRepository };
